<template>
  <div class="message-container text-center animated fadeInDown">
    <h2 class="message-title font-bold">{{$t('view.sessionExpiredMessage.titleFirstPart')}} {{userName}}{{$t('view.sessionExpiredMessage.titleSecondPart')}}</h2>
    <p class="message-instruction">
      {{$t('view.sessionExpiredMessage.instructions')}}
    </p>
    <div class="sk-spinner sk-spinner-circle">
        <div class="sk-circle1 sk-circle"></div>
        <div class="sk-circle2 sk-circle"></div>
        <div class="sk-circle3 sk-circle"></div>
        <div class="sk-circle4 sk-circle"></div>
        <div class="sk-circle5 sk-circle"></div>
        <div class="sk-circle6 sk-circle"></div>
        <div class="sk-circle7 sk-circle"></div>
        <div class="sk-circle8 sk-circle"></div>
        <div class="sk-circle9 sk-circle"></div>
        <div class="sk-circle10 sk-circle"></div>
        <div class="sk-circle11 sk-circle"></div>
        <div class="sk-circle12 sk-circle"></div>
    </div>
  </div>
</template>
<script>
import Auth from '@/services/auth';
import * as actions from '@/constants/mutation-names';

const usuario={
  username:""
}
export default {
  name: "SessionExpiredMessage"
  , head: {
    title: function() {
      return {
        inner       : this.view.title
        , separator : '|'
        , complement: this.$t("view.home.system.initials")
      };
    }
  }
  , data() {
    let _locale = this.$store.language;
    return {
      usuario
      , locale: _locale
      , view:{
        title:"Sesión Expirada"
        , errorMessage:{
          visible:false
          , text:""
        }
      }
    };
  }
  ,methods: {
    delayLogOut(){
      setTimeout( this.logOut, 5000);
    }
    , async logOut() {
      try {
        this.$store.dispatch(actions.STOP_ID_SESSION_TIME_INTERVAL);
        const respuesta = await Auth.logOut();
        this.$store.dispatch(actions.AUTH_LOGOUT);
        this.$router.push("/auth");
      } catch (error) {
       throw error;
      }
    }
  }
  , computed:{
    userName(){
      return this.usuario.nombre;
    }
  }
  , created(){
    if(this.$route.params.username){
      const {username, nombre}=this.$route.params;
      this.usuario.username = username;
      this.usuario.nombre = nombre;
      this.delayLogOut();
    }else{
      this.$router.push("/401Unauthorized")
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.message-container{
  position:absolute;
  top: 30%; bottom:0; left:0; right:0;
  transform: translateY(-30%);
}
.message-title{
  margin-bottom: 15px;
  color:white;
  font-weight: bolder;
}
.message-instruction{
  margin-bottom: 15px;
  color:"#dadada";
}
</style>



// WEBPACK FOOTER //
// src/views/authentication/SessionExpiredMessage.vue